import {
  FETCH_EDI_RESPONSE_RECORD_REQUEST,
  FETCH_EDI_RESPONSE_RECORD_SUCCESS,
  FETCH_EDI_RESPONSE_RECORD_FAILURE,
  CLEAR_EDI_RESPONSE_RECORDS,
} from "../actionTypes";

const intialState = {
  loading: null,
  ediRespRecords: [],
  error: "",
};

const ediRespRecordsReducer = (state = intialState, action) => {
  switch (action.type) {
    case FETCH_EDI_RESPONSE_RECORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_EDI_RESPONSE_RECORD_SUCCESS:
      return {
        loading: false,
        ediRespRecords: action.payload,
        error: "",
      };
    case FETCH_EDI_RESPONSE_RECORD_FAILURE:
      return {
        loading: false,
        ediRespRecords: [],
        error: action.payload,
      };
    case CLEAR_EDI_RESPONSE_RECORDS:
      return {
        loading: null,
        ediRespRecords: [],
        error: "",
      };
    default:
      return state;
  }
};
export default ediRespRecordsReducer;
